import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../../components/ui/button";

export default function PerformanceHeader({ month, year, mtd, onPrev, onNext, MONTHS }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-2xl font-light" style={{ fontFamily: 'var(--font-sans)' }}>Artist Performance</h1>
        <p className="text-sm text-muted-foreground mt-1">Cost & capacity intelligence</p>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="icon" onClick={onPrev}>
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <div className="text-center min-w-[140px]">
          <p className="font-medium">{MONTHS[month - 1]} {year}</p>
          <p className="text-xs text-muted-foreground">{mtd ? "MTD" : "Full Month"}</p>
        </div>
        <Button variant="outline" size="icon" onClick={onNext}>
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
